// caminho: apps/web/src/constants/permissions.js
// data e hora da modificação: 2026-03-21 21:55

export const PERMISSIONS = {
  USERS_VIEW: "users.view",
  USERS_CREATE: "users.create",
  USERS_EDIT: "users.edit",
  USERS_UPDATE: "users.update",
  USERS_DELETE: "users.delete",
  USERS_PERMISSIONS: "users.permissions",

  EVENTS_VIEW: "events.view",
  EVENTS_CREATE: "events.create",
  EVENTS_EDIT: "events.edit",
  EVENTS_UPDATE: "events.update",
  EVENTS_DELETE: "events.delete",
  EVENTS_MANAGE: "events.manage",

  COMMUNICATION_VIEW: "communication.view",
  COMMUNICATION_MANAGE: "communication.manage",

  INTEGRATIONS_VIEW: "integrations.view",
  INTEGRATIONS_MANAGE: "integrations.manage",

  EVENT_DASHBOARD_VIEW: "event.dashboard.view",

  EVENT_REGISTRATION_VIEW: "event.registration.view",
  EVENT_REGISTRATION_CREATE: "event.registration.create",
  EVENT_REGISTRATION_EDIT: "event.registration.edit",
  EVENT_REGISTRATION_DELETE: "event.registration.delete",
  EVENT_REGISTRATION_PRINT: "event.registration.print",
  EVENT_REGISTRATION_IMPORT: "event.registration.import",

  EVENT_CHECKIN_USE: "event.checkin.use",

  EVENT_REPORT_VIEW: "event.report.view",

  EVENT_TEAM_VIEW: "event.team.view",
  EVENT_TEAM_MANAGE: "event.team.manage",

  EVENT_DETAILS_VIEW: "event.details.view",
  EVENT_DETAILS_MANAGE: "event.details.manage",

  EVENT_CERTIFICATE_VIEW: "event.certificate.view",
  EVENT_CERTIFICATE_MANAGE: "event.certificate.manage",

  EVENT_EMAIL_LOG_VIEW: "event.emailLog.view",

  EVENT_EMAIL_TEMPLATE_MANAGE: "event.emailTemplate.manage",
  EVENT_PUBLIC_FORM_MANAGE: "event.publicForm.manage",
  EVENT_TOTEM_MANAGE: "event.totem.manage",
  EVENT_LABELS_MANAGE: "event.labels.manage",

  EVENT_PUBLIC_PAGE_VIEW: "event.publicPage.view",
  EVENT_PUBLIC_PAGE_MANAGE: "event.publicPage.manage",

  // =========================
  // EXHIBITORS (EXPOSITORES)
  // =========================
  EVENT_EXHIBITOR_VIEW: "event.exhibitor.view",
  EVENT_EXHIBITOR_CREATE: "event.exhibitor.create",
  EVENT_EXHIBITOR_EDIT: "event.exhibitor.edit",
  EVENT_EXHIBITOR_DELETE: "event.exhibitor.delete",

  EVENT_EXHIBITOR_USER_VIEW: "event.exhibitorUser.view",
  EVENT_EXHIBITOR_USER_CREATE: "event.exhibitorUser.create",
  EVENT_EXHIBITOR_USER_EDIT: "event.exhibitorUser.edit",
  EVENT_EXHIBITOR_USER_DELETE: "event.exhibitorUser.delete",

  EVENT_EXHIBITOR_IMPORT_VIEW: "event.exhibitorImport.view",
  EVENT_EXHIBITOR_IMPORT_CREATE: "event.exhibitorImport.create",
  EVENT_EXHIBITOR_IMPORT_REPROCESS: "event.exhibitorImport.reprocess",

  EVENT_EXHIBITOR_LEAD_VIEW: "event.exhibitorLead.view",
  EVENT_EXHIBITOR_LEAD_EXPORT: "event.exhibitorLead.export",

  EVENT_EXHIBITOR_UNMATCHED_VIEW: "event.exhibitorUnmatched.view",
};

export const ROLE_DEFAULT_PERMISSIONS = {
  ADMIN: ["*"],

  MANAGER: [
    PERMISSIONS.EVENT_DASHBOARD_VIEW,
    PERMISSIONS.EVENT_REGISTRATION_VIEW,
    PERMISSIONS.EVENT_REGISTRATION_CREATE,
    PERMISSIONS.EVENT_REGISTRATION_EDIT,
    PERMISSIONS.EVENT_REGISTRATION_DELETE,
    PERMISSIONS.EVENT_REGISTRATION_PRINT,
    PERMISSIONS.EVENT_CHECKIN_USE,
    PERMISSIONS.EVENT_REPORT_VIEW,
    PERMISSIONS.EVENT_TEAM_VIEW,
    PERMISSIONS.EVENT_TEAM_MANAGE,
    PERMISSIONS.EVENT_DETAILS_VIEW,
    PERMISSIONS.EVENT_DETAILS_MANAGE,
    PERMISSIONS.EVENT_CERTIFICATE_VIEW,
    PERMISSIONS.EVENT_CERTIFICATE_MANAGE,
    PERMISSIONS.EVENT_EMAIL_LOG_VIEW,
    PERMISSIONS.EVENT_EMAIL_TEMPLATE_MANAGE,
    PERMISSIONS.EVENT_PUBLIC_FORM_MANAGE,
    PERMISSIONS.EVENT_TOTEM_MANAGE,
    PERMISSIONS.EVENT_LABELS_MANAGE,
    PERMISSIONS.EVENT_PUBLIC_PAGE_MANAGE,

    PERMISSIONS.EVENT_EXHIBITOR_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_CREATE,
    PERMISSIONS.EVENT_EXHIBITOR_EDIT,
    PERMISSIONS.EVENT_EXHIBITOR_DELETE,

    PERMISSIONS.EVENT_EXHIBITOR_USER_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_USER_CREATE,
    PERMISSIONS.EVENT_EXHIBITOR_USER_EDIT,
    PERMISSIONS.EVENT_EXHIBITOR_USER_DELETE,

    PERMISSIONS.EVENT_EXHIBITOR_IMPORT_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_IMPORT_CREATE,
    PERMISSIONS.EVENT_EXHIBITOR_IMPORT_REPROCESS,

    PERMISSIONS.EVENT_EXHIBITOR_LEAD_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_LEAD_EXPORT,
    PERMISSIONS.EVENT_EXHIBITOR_UNMATCHED_VIEW,
  ],

  STAFF: [
    PERMISSIONS.EVENT_DASHBOARD_VIEW,
    PERMISSIONS.EVENT_REGISTRATION_VIEW,
    PERMISSIONS.EVENT_REGISTRATION_CREATE,
    PERMISSIONS.EVENT_REGISTRATION_EDIT,
    PERMISSIONS.EVENT_REGISTRATION_PRINT,
    PERMISSIONS.EVENT_CHECKIN_USE,
    PERMISSIONS.EVENT_REPORT_VIEW,
    PERMISSIONS.EVENT_CERTIFICATE_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_IMPORT_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_IMPORT_CREATE,
    PERMISSIONS.EVENT_EXHIBITOR_LEAD_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_LEAD_EXPORT,
    PERMISSIONS.EVENT_EXHIBITOR_UNMATCHED_VIEW,
  ],

  VIEWER: [
    PERMISSIONS.EVENT_DASHBOARD_VIEW,
    PERMISSIONS.EVENT_REGISTRATION_VIEW,
    PERMISSIONS.EVENT_REPORT_VIEW,
    PERMISSIONS.EVENT_DETAILS_VIEW,
    PERMISSIONS.EVENT_CERTIFICATE_VIEW,
    PERMISSIONS.EVENT_EMAIL_LOG_VIEW,

    PERMISSIONS.EVENT_EXHIBITOR_VIEW,
    PERMISSIONS.EVENT_EXHIBITOR_LEAD_VIEW,
  ],
};